import { useState } from 'react'

import { AddButton } from '#app/routes/mocra+/_form+/components/add-button.tsx'
import { AeSystemOverlay } from '#app/routes/mocra+/_form+/components/ae-systems/overlay.tsx'
import {
	createAeSystemDraft,
	type AeSystemDraft,
} from '#app/routes/mocra+/_form+/components/ae-systems/types.ts'

type Props = {
	onSubmit: (draft: AeSystemDraft) => void
	defaultValue?: AeSystemDraft
	triggerLabel?: string
	disabled?: boolean
	className?: string
}

export function AeSystemAdd({
	onSubmit,
	defaultValue,
	triggerLabel,
	disabled,
	className,
}: Props) {
	const [open, setOpen] = useState(false)

	const handleSubmit = (draft: AeSystemDraft) => {
		onSubmit(draft)
		setOpen(false)
	}

	return (
		<>
			<AddButton
				onClick={() => setOpen(true)}
				disabled={disabled}
				className={className}
			>
				{triggerLabel ?? 'Add system'}
			</AddButton>
			<AeSystemOverlay
				mode="add"
				open={open}
				onOpenChange={setOpen}
				onSubmit={handleSubmit}
				initialValue={defaultValue ?? createAeSystemDraft()}
				onClosed={() => setOpen(false)}
			/>
		</>
	)
}
